import React from "react";
import { Loader2, Sparkles } from "lucide-react";
import { STATUS_OPTIONS } from "@/pages/admin/contact/constants";

/**
 * Pipeline KPI strip — one card per status with the live count + a
 * one-click "follow up everyone whose quote is due" CTA when applicable.
 */
const PipelineStats = ({
  stats,
  lang,
  onFilter,
  runningFollowups,
  onRunFollowups,
}) => {
  if (!stats) return null;
  return (
    <div>
      <div className="flex items-baseline justify-between mb-3">
        <p className="overline kw-accent-line">Pipeline</p>
        {stats.followup_due > 0 && (
          <button
            type="button"
            onClick={onRunFollowups}
            disabled={runningFollowups}
            data-testid="admin-run-followups-btn"
            className="text-[10px] uppercase tracking-[0.25em] px-3 py-2 border border-[#E8C66C] text-[#E8C66C] bg-[#E8C66C]/5 hover:bg-[#E8C66C]/10 transition-colors flex items-center gap-2 disabled:opacity-50"
          >
            {runningFollowups ? (
              <Loader2 className="w-3.5 h-3.5 animate-spin" strokeWidth={1.5} />
            ) : (
              <Sparkles className="w-3.5 h-3.5" strokeWidth={1.5} />
            )}
            {lang === "fr"
              ? `Relancer ${stats.followup_due} prospect${stats.followup_due > 1 ? "s" : ""}`
              : `Follow up ${stats.followup_due} prospect${stats.followup_due > 1 ? "s" : ""}`}
          </button>
        )}
      </div>
      <div className="grid grid-cols-3 sm:grid-cols-6 gap-3">
        {STATUS_OPTIONS.map((s) => (
          <div
            key={s.v}
            data-testid={`admin-pipeline-${s.v}`}
            className="border border-[#F2EBE5]/10 bg-[#0a0a0a] p-4 cursor-pointer hover:border-[#F2EBE5]/25 transition-colors"
            onClick={() => onFilter(s.v)}
          >
            <div className="text-[9px] uppercase tracking-[0.25em] text-[#A19E9C]">
              {lang === "fr" ? s.fr : s.en}
            </div>
            <div
              className="mt-2 font-serif-display text-3xl"
              style={{ color: s.color }}
            >
              {stats[s.v] ?? 0}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PipelineStats;
